// The "this person's data was erased" notice with its explicit go-ahead (Session ASQ, Stream G, Item 3's review, F5 and
// F7). When a create is refused 409 erased_person (lib/erasedPerson.ts reads it), a form shows the server's own sentence,
// naming the detail and the date, and ONE button that resends the same request with the server's own flag
// (createAnyway), which the server audits. Pressing the ordinary submit again never goes ahead: only this button does,
// so the override is always a deliberate choice, never a retry that happens to succeed.
export function ErasedPersonNotice({
  message,
  busy,
  onGoAhead,
  label = "Create anyway",
  busyLabel = "Creating...",
}: {
  message: string;
  busy: boolean;
  onGoAhead: () => void;
  label?: string;
  busyLabel?: string;
}) {
  return (
    <div role="alert" className="mt-3 rounded-ele border border-amber-400 bg-ele-surface p-3 text-sm text-ele-strong">
      <p>{message}</p>
      <button
        type="button"
        onClick={onGoAhead}
        disabled={busy}
        className="mt-2 rounded-ele border border-ele-danger px-3 py-1.5 font-menu text-xs tracking-wide text-ele-danger disabled:opacity-50"
      >
        {busy ? busyLabel : label}
      </button>
    </div>
  );
}
